import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.splice.js";
import { LocationFilled, Close, RefreshLeft, CircleClose } from "@element-plus/icons-vue";
export default {
  components: {
    LocationFilled: LocationFilled
  },
  data: function data() {
    return {
      index: 0,
      //接收下标用来判断刷新哪一个就跳转哪一个
      tags: [{
        title: "系统介绍",
        name: "home",
        path: "/index/home"
      }],
      //标签页数据
      isCollapse: false //折叠菜单的数据

    };
  },
  setup: function setup() {
    return {
      CircleClose: CircleClose,
      RefreshLeft: RefreshLeft,
      Close: Close
    };
  },
  watch: {
    $route: function $route() {
      if (this.$route.name == "home" || this.$route.name == "redirect-child") {
        //判断如果是首页就不添加
        return;
      }

      for (var i = 0; i < this.tags.length; i++) {
        //循环判断去重
        if (this.tags[i].name == this.$route.name) {
          return false;
        }
      }

      this.tags.push({
        title: this.$route.meta.title,
        name: this.$route.name,
        path: this.$route.path
      });
    }
  },
  created: function created() {
    if (this.$route.name != "home" && this.$route.name != undefined) {
      //判断刷新显示选中的菜单
      this.tags.push({
        title: this.$route.meta.title,
        name: this.$route.name,
        path: this.$route.path
      });
    }
  },
  methods: {
    context: function context(index) {
      //右击判断是否是最后一个
      document.body.click();
    },
    meuns: function meuns(indexs) {
      //下拉菜单
      var num = indexs.num,
          index = indexs.index,
          path = indexs.path;
      var router = this.$router;
      var tags = this.tags;

      switch (num) {
        case 1:
          router.push({
            path: "/redirect".concat(path.path)
          });
          break;

        case 2:
          // 点击关闭右侧标签
          router.push({
            name: tags[index].name
          });
          tags.splice(index + 1);
          break;

        case 3:
          // 点击全部关闭
          router.push({
            name: "home"
          });
          tags.splice(1);
          break;

        default:
          break;
      }
    },
    tagCiclk: function tagCiclk(index) {
      //点击跳转指定路由列表
      this.$router.push({
        name: this.tags[index].name
      });
    },
    deletes: function deletes(index) {
      //删除
      if (this.$route.name == this.tags[index].name) {
        if (this.tags.length - 1 == index) {
          //判断是否是最后一个
          this.$router.push({
            name: this.tags[index - 1].name
          });
        } else {
          this.$router.push({
            name: this.tags[index + 1].name
          });
        }
      }

      this.tags.splice(index, 1);
    }
  }
};